import React from 'react';
import { Link } from 'gatsby';
import DeudorIcon from './DeudorIcon';
import FactoradoIcon from './FactoradoIcon';
import InversionistaIcon from './InversionistaIcon';

type Icon = 'factorado' | 'inversionista' | 'deudor';

interface Props {
  icon: Icon;
  to: string;
  title: string;
  description: string;
  linkText?: string;
  className?: string;
}

const HomeFeature = (props: Props) => {
  const {
    icon,
    title,
    description,
    to,
    className,
    linkText = 'Leer más →',
  } = props;

  return (
    <article className={`${className} mb-8`}>
      <header className="mb-4 feature">
        {icon === 'factorado' && <FactoradoIcon />}
        {icon === 'inversionista' && <InversionistaIcon />}
        {icon === 'deudor' && <DeudorIcon />}
      </header>
      <footer>
        <h3 className="text-gray-700 mb-4 text-2xl md:text-3xl">{title}</h3>
        <p className="text-gray-700 mb-4 text-lg leading-relaxed">
          {description}
        </p>
        <Link
          to={to}
          className="text-green-100 text-xl md:text-2xl font-semibold tracking-wider"
        >
          {linkText}
        </Link>
      </footer>
    </article>
  );
};

export default HomeFeature;
